/*
 * Google+ Auth
 * Google Auth Javscript SDK v??
 * @author: Elton Jain
 *
 * Methods
 * - doLogin()
 * - doLogout()
 * - checkLoginState()
 */

define('modules/auth/google',['jquery', 'Config', 'UI','History'], function($, Config, UI, History) {

    'use strict';

    var APP_ID = Config.get('GOOGLE_APP_ID'),
        // APP_ID = '1004252111741-p7gbg8eb17fh9ua589tlk02dobjuc2fd.apps.googleusercontent.com', // Live
        // APP_ID_LOCAL = '391910776681-q2vrehqprrkhqu63mi69qiigar333l7r.apps.googleusercontent.com', // Localhost
        APP_SCOPE = 'https://www.googleapis.com/auth/plus.login ' +
        'https://www.googleapis.com/auth/userinfo.email ' +
        'https://www.googleapis.com/auth/userinfo.profile ' +
        'https://www.googleapis.com/auth/plus.me',
        SDKLOADED = false;

    var Google = {

        loginState: null, // Stores the GooglePlus Login state
        loginOptions: {}, // Params passed for login
        triggerLogin: false, // If to initiate login after SDk
        redirect_url: null,
        extraData: {},

        /*
         * Initialization
         */
        loadSDK: function (callback) {
            window.googleAsyncInit = function () {
                SDKLOADED = true;
                if(callback) {
                    callback();
                }
            }
            (function(d, s, id){
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) {return;}
                js = d.createElement(s); js.id = id;
                js.src = "//apis.google.com/js/client:platform.js?onload=googleAsyncInit";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'google-jssdk'));
        },

        init: function() {
            if(!SDKLOADED || !gapi) {
                this.loadSDK();
            }
        },

        /*
         * Log into GooglePlus api
         * If already login, just return login state
         */
        doLogin: function(options, callback) {
            var base = this;

            base.loginOptions = options;

            if (base.loginOptions.redirect_url) {
                base.redirect_url = options.redirect_url;
            }

            base.extraData = $.extend(base.extraData, options);

            // Login Button Clicked Mixpanel Event
            require(['Mixpanel'], function(MixPanel) {

                MixPanel.hit('login_click', {
                    login_type: 'Google',
                    trigger_source: base.extraData.trigger_source,
                });
            });

            var params = {
                'client_id': APP_ID,
                'scope': APP_SCOPE,
                'cookie_policy': 'single_host_origin',
                'authuser': -1,
                'response_type': 'token id_token'
            };

            if(window.gapi && window.gapi.auth) {
                gapi.auth.authorize(params, base.statusChangeCallback);

                if (callback) {
                    callback();
                }
            } else {
                UI.$b.addClass('loading');
                setTimeout(function () {
                    base.doLogin(options, callback);
                }, 500);
            }

            return this.loginState;
        },

        /*
         * Logout GooglePlus
         */
        doLogout: function(callback) {
            this.loginState = false;

            if (callback) {
                callback();
            }
        },

        /*
         * Check Login status
         * @returns status (connected, not_authorized)
         */
        checkLoginState: function() {
            var base = this;

            return base.loginState;
        },

        /*
         * Trigger when GooglePlus state is changed
         */
        statusChangeCallback: function(response) {
            UI.$b.removeClass('loading');
            // Cannot use 'this' as its a callback
            if (Google.loginState === 'connected') {
                return false;
            }
            if (response.status.signed_in && response.status.method === 'PROMPT') {
                // User clicked on the sign in button. Do your staff here.
                // Update the app to reflect a signed in user
                Google.loginState = 'connected';
                Google.postLogin(response);

            } else if (response.status.signed_in) {
                // This is called when the status has changed and method is not 'PROMPT'.
                Google.loginState = 'connected';
                Google.postLogin(response);
            } else {
                // Update the app to reflect a signed out user
                // Possible error values:
                //   'user_signed_out' - User is signed-out
                //   'access_denied' - User denied access to your app
                //   'immediate_failed' - Could not automatically log in the user
                //console.log('Sign-in state: ' + response['error']);
                Google.loginState = false;
            }
        },

        /*
         * Fetch and update data after GooglePlus Auth Login or Sign up
         */
        postLogin: function(tokenResponse) {

            var base = this,
                user = {};

            UI.$b.addClass('loading');

            function reloadPostLogin (response) {
                if (base.redirect_url) {
                    window.location.href = base.redirect_url;
                } else if (response.redirect_url) {
                    window.location.href = response.redirect_url;
                } else {
                    window.location.reload();
                }
            }

            /*
                // VERSION 1
            */
            gapi.client.load('plus', 'v1', function() {
                gapi.client.plus.people.get({
                    'userId': 'me'
                }).execute(function(response) {

                    // Shows profile information
                    //console.log(response);
                    
                    // If no name provided by google execute code below
                    if(!response.name || !response.name.givenName) {
                        var name = prompt("Please enter your full name");
                        if (name === null) {
                            require(['Toastr'], function (Toastr) {
                                new Toastr({
                                    'class': 'toastr-error',
                                    'message': 'We need to know your name!!',
                                    'icon': 'ion-close-round'
                                });
                            });
                            UI.$b.removeClass('loading');
                            return false;
                        } else {
                            response.name = {givenName: name};
                        }
                    }

                    user = {
                        auth_type: 'googleplus',
                        id: response.id,
                        image: response.image ? response.image.url : null,
                        fname: response.name ? response.name.givenName : null,
                        lname: response.name ? response.name.familyName : null,
                        name: response.displayName,
                        gender: response.gender,
                        email: response.emails ? response.emails[0].value : null,
                        birthdate: response.birthday,
                        //hometown: response.placesLived[0].value,
                        timezone: response.timezone,
                        work: response.organizations,
                        locale: response.language,
                        id_token: tokenResponse.id_token
                    };
                    user = $.extend(user, base.extraData);

                    // Send login info
                    $.post('/ajax/user/login_google', user, function(response) {
                        var mixpanelData = {},
                            mixpanelApi = 'login';

                        if (response.status === true) {
                            if(window.location.hash !== '') {
                                History.popState();
                            }

                            // If mixpanel is late
                            setTimeout(function () {
                                reloadPostLogin(response);
                            }, 5000);

                            try {
                            
                                if(response.response) {
                                    mixpanelData = {
                                        firstname: user.fname || '',
                                        lastname: user.lname || '',
                                        created_at: response.response.created_at,
                                        email: user.email,
                                        gender: user.gender || '',
                                        timezone: user.timezone || '',
                                        birthday: user.birthday || '',
                                        user_id: response.response.id
                                    };
                                }
                                if (response.response && response.response.is_new === true) {
                                    mixpanelApi = 'signup';
                                }

                                mixpanelData.login_type = 'Google';
                                mixpanelData.trigger_source = base.extraData.trigger_source;

                                // Time limit 2sec
                                require(['Mixpanel'], function(MixPanel) {
                                    MixPanel.hit(mixpanelApi, mixpanelData, function() {
                                        reloadPostLogin(response);
                                        UI.$b.removeClass('loading');
                                    });
                                });
                            } catch (e) {
                                require(['Toastr'], function (Toastr) {
                                    new Toastr({
                                        'message': e.message
                                    });
                                });
                                UI.$b.removeClass('loading');
                                reloadPostLogin(response);
                            }


                        } else if (response.status === false) {
                            UI.$b.removeClass('loading');
                            if (response.redirect_url) {
                                window.location.href = response.redirect_url;
                            } else {
                                alert(response.message);
                            }
                        }
                    });
                });
            });


            // VERSION 2
            /*gapi.client.load('oauth2', 'v2', function() {
              gapi.client.oauth2.userinfo.get().execute(function(resp) {
                // Shows user email
                console.log(resp);
              })
            });*/


        },

        /*
         * Format relationship status
         */
        convertRelationshipStatus: function(str) {

            if (!str) {
                return null;
            }

            str = str.toLowerCase();

            if (str.indexOf('single')) {
                return 'single';
            } else if (str.indexOf('open relationship')) {
                return 'open_relationship';
            } else if (str.indexOf('in a relationship')) {
                return 'in_relationship';
            } else if (str.indexOf('married')) {
                return 'married';
            } else if (str.indexOf('engaged')) {
                return 'engaged';
            } else if (str.indexOf('separated')) {
                return 'separated';
            } else if (str.indexOf('divorced')) {
                return 'divorced';
            } else if (str.indexOf('widowed')) {
                return 'widowed';
            } else if (str.indexOf('complicated')) {
                return 'complicated';
            }

            return null;
        }

    };

    return Google;
});
